module.exports = __webpack_public_path__ + "d1e548dcf30fb9f27ac3d9d8d02e83e0.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/157.png
// module id = 1752
// module chunks = 2